define('app/flow-manager',['require','./views/baseview'],function(require){

  var BaseView = require('./views/baseview');

  var FlowManager = function(flow){
    this.initialize(flow);
  };

  _.extend(FlowManager.prototype, {

    flow: FlowManager.NORMAL,
    inPage: null,
    outPage: null,
    pendingPages: [],

    initialize: function(flow){
      this.setFlow(flow);
    },

    setFlow: function(flow){
      this.flow = flow ? flow : FlowManager.NORMAL;
    },

    getFlow: function(){
      return this.flow;
    },

    goto: function(newPageView, activePageView, flow){
      if(this.inPage || this.outPage){
        this.pendingPages = [newPageView, activePageView];
        return;
      }

      this.inPage = newPageView;
      this.outPage = activePageView;

      var flow = (flow || this.flow);
      if(this.flows[flow]){
        this.flows[flow].call(this, newPageView, activePageView);
      } else {
        console.log('flow manager does not support flow: ' + flow);
      }
    },

    complete: function(){
      this.inPage = null;
      this.outPage = null;
      if(this.pendingPages.length){
        this.swap.apply(this, this.pendingPages);
        this.pendingPages = [];
        return false;
      }
      return true;
    },

    flows: {

      normal: function (newPageView, activePageView) {
        var _self = this;

        newPageView.on(BaseView.AFTER_LOADED, function(){
          if(_self.complete()){
            this.off(BaseView.AFTER_LOADED);
            window.iws.site.setActivePageView(this);
            this.show();
          }
        });

        if(activePageView) {
          activePageView.on(BaseView.AFTER_HIDE, function () {
            newPageView.preload();
          });
        }

        activePageView ? activePageView.hide() : newPageView.preload();
      },

      preload: function (newPageView, activePageView) {
        var _self = this;

        newPageView.on(BaseView.AFTER_LOADED, function(){
          this.off(BaseView.AFTER_LOADED);
          if(activePageView){
            activePageView.on(BaseView.AFTER_HIDE, function () {
              if(_self.complete()) {
                this.off(BaseView.AFTER_HIDE).$el.detach();
                window.iws.site.setActivePageView(newPageView);
                newPageView.show();
              }
            }).hide();
          } else {
            if(_self.complete()){
              window.iws.site.setActivePageView(newPageView);
              newPageView.show();
            }
          }
        }).preload();
      },

      cross: function (newPageView, activePageView) {
        var _self = this;

        newPageView.on(BaseView.AFTER_LOADED, function(){
          if(_self.complete()){
            window.iws.site.setActivePageView(newPageView);
            if(activePageView) activePageView.hide();
            newPageView.show()
          }
        }).preload();
      },

      reverse: function (newPageView, activePageView) {
        var _self = this;

        newPageView.on(BaseView.AFTER_LOADED, function(){
          if(_self.complete()){
            window.iws.site.setActivePageView(newPageView);
            newPageView.show();
          }
        }).on(BaseView.AFTER_SHOW, function(){
          if(activePageView) activePageView.hide();
        }).preload();
      }

    }

  });

  FlowManager.NORMAL = 'normal';
  FlowManager.PRELOAD = 'preload';
  FlowManager.CROSS = 'cross';
  FlowManager.REVERSE = 'reverse';

  return FlowManager;

});
